export const SET_FROM = "SET_FROM";
export const SET_TO = "SET_TO";
export const SET_HOW = "SET_HOW";
export const SET_DATE = "SET_DATE";
export const SET_IS_VAC = "SET_IS_VAC";
export const UPDATE_TIME_TABLE = "UPDATE_TIME_TABLE";